module.exports = __webpack_public_path__ + "img/expansion.4b0d229e.webp";